import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import Alert from "../../components/Alert";
import ResponseUtils from "../../utils/ResponseUtils";
import history from "../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import FormSelect from "../../Controls/Select";
import { findByNumeroCedula } from "services/DatosPersonalesService";
import { trackPromise } from "react-promise-tracker";
import FormDatePicker from "../../Controls/DatePicker";
import { findByNumeroCedulaFechaNac } from "services/DatosPersonalesService";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  button: {
    margin: theme.spacing(2),
  },
  okButton: {
    color: "#fff",
    backgroundColor: "#01C12B",
    margin: theme.spacing(),
  },
  denyButton: {
    color: "#fff",
    backgroundColor: "#ff0000",
    margin: theme.spacing(),
  },
  title: {
    fontSize: 14,
  },
}));


const Form = () => {
  const classes = useStyles();
  const [sent, setSent] = useState(false);
  const params = useParams();
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [editarResponsable, setEditarResponsable] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [responsableResponseData, setResponsableResponseData] = useState({});
  const [nombreServicioOptions, setNombreServicioOptions] = useState([]);
  const methods = useForm({});
  const { handleSubmit, errors, reset, setValue, getValues } = methods;
  let { state } = useLocation();
  const [departamentosOptions, setdepartamentosOptions] = useState([]);
  const [ciudadOptions, setCiudadOptions] = useState([]);
  const tipoInstitucionOptions = [{
    id: 1,
    label: "Pública",
  },
  {
    id: 2,
    label: "Privada",
  }];
  useEffect(() => {
    const load = () => {
      try {
       
        setValuesForEdit();
        setIsAddMode(true);
        setIsReadOnly(state?.edit===true?true:false);

      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }

  const setValuesForEdit = async () => {
    try {
      const { data: response } = await DnerhsApi.get(`/instituciones/formadoras/${params.institucionFormadoraId}/responsables`);
      setResponsableResponseData(response);

          const values = {
            apellidos: response.responsable.apellidos,
            ci: response.responsable.cedulaIdentidad,
            email: response.responsable.email,
            nombres: response.responsable.nombres,
            telefono: response.responsable.telefono,
            aci: response.maximaAutoridad.cedulaIdentidad,
            anombre: response.maximaAutoridad.nombres,
            aapellido: response.maximaAutoridad.apellidos,
            cargo: response.maximaAutoridad.cargo,
            aemail: response.maximaAutoridad.email,
            atelefono: response.maximaAutoridad.telefono,
          };
          const fields = [
          
           
         
           
            "apellidos",
            "ci",
            "email",
            "nombres",
            "telefono",
            "aci",
            "anombre",
            "aapellido",
            "cargo",
            "aemail",
            "atelefono",
          ];
    
          fields.forEach((x) => setValue(x, values[x]));
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const onSubmit = async (data) => {
    try {
      let url = "/instituciones/formadoras/responsables";     
      let payloadput=responsableResponseData;
      //RESPONSABLE
      payloadput.responsable.nombres=data.nombres;
      payloadput.responsable.cedulaIdentidad=data.ci;
      payloadput.responsable.apellidos=data.apellidos;
      payloadput.responsable.email= data.email;
      payloadput.responsable.telefono= data.telefono;
       //MAXIMA AUTORIDAD
       payloadput.maximaAutoridad.nombres=data.anombre;
       payloadput.maximaAutoridad.cedulaIdentidad=data.aci;
       payloadput.maximaAutoridad.apellidos=data.aapellido;
       payloadput.maximaAutoridad.email= data.aemail;
       payloadput.maximaAutoridad.telefono= data.atelefono;
       payloadput.maximaAutoridad.cargo= data.cargo;
      await trackPromise(DnerhsApi.put(url, {
        ...payloadput,
      }));      
      setSent(true)
      Alert.show(
        {
          message: "Responsables de Institucion editados con éxito.",
          type: "success"
        }
      )
      history.push(`/institucionesFormadoras`);
    } catch(error) {
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }

  }
  const handleResetResponsable = () => {   
    setValue("nombres","");
    setValue("apellidos", "");
    setValue("fechaNacimiento", null);
  }
  const handleResetMaximaAutoridad = () => {   
  setValue("anombre","");
  setValue("aapellido", "");
  setValue("afechaNacimiento", null);
  }
  /*const handleFindDatosPersonales = async (event) => {
    let {target} = event;
    let fechaNac= target.value.split('-');
    const { data } = await trackPromise(findByNumeroCedulaFechaNac(getValues("ci"), fechaNac[2]+"-"+fechaNac[1]+"-"+fechaNac[0] ));
    if (data.numeroCedula!=null  && data.fechaNacimiento!=null) {
      setValue("nombres", data.nombres);
      setValue("apellidos", data.apellidos);
    }else{
      setValue("nombres","");
      setValue("apellidos", "");
      setValue("fechaNacimiento", "");

      Alert.show({
        message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
        type: "warning",
      });
    }
  }*/
  const handleFindDatosPersonales = async (event) => {
    let {target} = event;
    let fechaNac= target.value!="" ?  target.value.split('-') : "";
    let nrocedula= getValues("ci");
    if ((fechaNac!=null && typeof(fechaNac) != 'undefined' && fechaNac!="") && (nrocedula!=null && typeof(nrocedula) != 'undefined'  && nrocedula!="")) {
      const { data } = await trackPromise(findByNumeroCedulaFechaNac(nrocedula, fechaNac[2]+"-"+fechaNac[1]+"-"+fechaNac[0] ));
      if (data.numeroCedula!=null && typeof(data.numeroCedula) != 'undefined') {
        setValue("nombres", data.nombres);
        setValue("apellidos", data.apellidos);
      }else{
        setValue("nombres","");
        setValue("apellidos", "");
        Alert.show({
          message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
          type: "warning",
        });
      }
    }
  }
  /*const handleFindDatosPersonalesMaximaAutoridad = async (event) => {//editar
    let {target} = event;
    let fechaNac= target.value.split('-');
    const { data } = await trackPromise(findByNumeroCedulaFechaNac(getValues("aci"), fechaNac[2]+"-"+fechaNac[1]+"-"+fechaNac[0] ));
    if (data.numeroCedula!=null && fechaNac.length===3) {
      setValue("anombre", data.nombres);
      setValue("aapellido", data.apellidos);
    }else{
      setValue("anombre","");
      setValue("aapellido", "");
      setValue("afechaNacimiento", "");
      Alert.show({
        message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
        type: "warning",
      });
    }
  }*/
  const handleFindDatosPersonalesMaximaAutoridad = async (event) => {
    let {target} = event;
    let fechaNac=  target.value!="" ?  target.value.split('-') : "";
    let nrocedula= getValues("aci");
    if ((fechaNac!=null && typeof(fechaNac) != 'undefined' && fechaNac!="") && (nrocedula!=null && typeof(nrocedula) != 'undefined'  && nrocedula!="")) {
      const { data } = await trackPromise(findByNumeroCedulaFechaNac(nrocedula, fechaNac[2]+"-"+fechaNac[1]+"-"+fechaNac[0] ));
      if (data.numeroCedula!=null) {
        setValue("anombre", data.nombres);
        setValue("aapellido", data.apellidos);
      }else{
        setValue("anombre","");
        setValue("aapellido", "");
        Alert.show({
          message: `Los datos no coinciden, datos incorrectos. Por favor intente nuevamente.`,
          type: "warning",
        });
      }
    }
  }
  const handleHabilitar= (event) =>  {
    if(event){
      setIsReadOnly(false);
      setIsUpdate(true);
    }
   // 
  }
  return (
    <div className={classes.main}>
      <Grid item xs={12}>
        {isAddMode ? (
          <Typography
            align="center"
            variant="h5"
            color="primary"
            className={classes.form}
          >
            Datos de Responsables de la Institución Formadora
          </Typography>
        ) : (
          <Typography
            align="center"
            variant="h5"
            color="primary"
            className={classes.form}
          >
            Establecimiento y usuario responsable
          </Typography>
        )}
      </Grid>
      <div>
        <FormProvider {...methods}>
          <Paper>
            <form>
            <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                  >
                    <Grid item xs={12} className={classes.field}>
                      <Typography align="center" variant="h6" color="primary">
                        Datos del Responsable
                      </Typography>
                    </Grid>
                    
                   
                    <Grid item xs={6} className={classes.form}>               
                      <Grid item xs={12} className={classes.field}  onBlur={() =>handleResetResponsable()}>
                        <FormInput
                          name="ci"
                          label="Cédula de Identidad"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                     
                      <Grid item xs={12} className={classes.field} onBlur={(e) => handleFindDatosPersonales(e)} >
                        <FormDatePicker 
                          name="fechaNacimiento" 
                          label="Fecha de Nacimiento"                  
                          disabled={!isAddMode}
                        />                          
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="telefono"
                          label="Teléfono"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                    </Grid>
                  
                    <Grid item xs={6} className={classes.form}>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="nombres"
                          label="Nombres"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="apellidos"
                          label="Apellidos"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                     
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="email"
                          label="E-mail"
                          errorobj={errors}
                          required
                          disabled={!isAddMode}
                        />
                      </Grid>
                    </Grid>
                    
                    
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={12} className={classes.field}>
                        <Typography align="center" variant="h6" color="primary">
                          Datos de la Máxima Autoridad de la Institución
                          Formadora
                        </Typography>
                      </Grid>
                      <Grid item xs={6} className={classes.form}>
                        <Grid item xs={12} className={classes.field} onBlur={() => handleResetMaximaAutoridad()}>
                          <FormInput
                            name="aci"
                            label="Cedula de Identidad"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                         
                      <Grid item xs={12} className={classes.field} onBlur={(e) => handleFindDatosPersonalesMaximaAutoridad(e)} >
                        <FormDatePicker 
                          name="afechaNacimiento" 
                          label="Fecha de Nacimiento"                  
                          disabled={!isAddMode}
                        />                          
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="cargo"
                            label="Cargo"
                            //options={cargoOptions}
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="aemail"
                            label="E-mail"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} className={classes.form}>
                      <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="anombre"
                            label="Nombres"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="aapellido"
                            label="Apellidos"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                       
                        <Grid item xs={12} className={classes.field}>
                          <FormInput
                            name="atelefono"
                            label="Teléfono"
                            disabled={!isAddMode}
                            errorobj={errors}
                            required
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                 
                 
                  </Grid>
            </form>
          </Paper>
        </FormProvider>
      </div>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        className={classes.form}
      >
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() => { history.goBack() }}
          >
            Atrás
          </Button>
        </Grid>
        {(isAddMode || isUpdate) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </Button>
          </Grid>
        }
         {(isReadOnly) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={(event) => { handleHabilitar(event) }}
            >
              Editar
            </Button>
          </Grid>
        }
           {(editarResponsable) &&
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {  history.push(`/institucionesFormadoras/editar/${responsableResponseData.id}`) }}  
            >
              Editar Responsables
            </Button>
          </Grid>
        }
      </Grid>

    </div>)
};

export default Form;
